module.exports = __webpack_public_path__ + "static/media/kitchen-business.5bda43cb.jpg";